var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',[(_vm.url)?[_c('router-link',{staticClass:"btn-action-link",attrs:{"to":_vm.url},domProps:{"innerHTML":_vm._s(_vm.text ? _vm.text : '(leeg)')}})]:[_vm._v(" (leeg) ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }